import React from "react";
import { useIntl } from "react-intl";
import cx from "classnames";
import PropTypes from "prop-types";
import moment from "moment-timezone";
import NoSearchResults from "@assets/emptySearch.svg";
import NoData from "@components/TinyComponents/Nodata";
import Button from "@salesforce/design-system-react/components/button";
// import Icon from "@salesforce/design-system-react/components/icon";
import localStorage from "@services/localStorage";
import ProductUpdateBadge from "@assets/img/annoucements/product.svg";
import AnnoucementBadge from "@assets/img/annoucements/annoucement.svg";
// import Icon from "react-multi-date-picker/components/icon";
import announcements from "./announcements";
import "./style.scss";

/**
 * Content Schema
 * @param {*} props
 * { "id", "title", "content", "link", "timestamp" }
 */
function AnnouncementContent(props) {
	const redirect = link => {
		window.open(link, "_blank");
		props.closeOverlay();
	};

	return (
		<div
			className={cx(
				"pc-announcement-content-card",
				!localStorage.getItem("announcements", props.id)
					? `${String(props.type).replace(" ", "-").toLowerCase()}-unread`
					: `${String(props.type).replace(" ", "-").toLowerCase()}-read`,
			)}
			id={props.id}
			role="listitem"
		>
			<div className="pc-content-tags">
				<div>
					<span
						className={cx(
							"tag",
							!localStorage.getItem("announcements", props.id)
								? `${String(props.type).replace(" ", "-").toLowerCase()}-unread`
								: `${String(props.type).replace(" ", "-").toLowerCase()}-read`,
						)}
					>
						<span>{props.type}</span>
					</span>
					<span className="date-txt">
						{moment(new Date(+props.id)).format("MMM DD, YYYY")}
					</span>
				</div>
				{!localStorage.getItem("announcements", props.id) && (
					<div className="new-announcement-badge">
						{props.type === "Announcement" ? (
							<div className="new-tag">
								<img src={AnnoucementBadge} alt="" />
								<span>New</span>
							</div>
						) : (
							<div className="new-tag">
								<img src={ProductUpdateBadge} alt="" />
								<span>New</span>
							</div>
						)}
					</div>
				)}
			</div>
			<h3 className="pc-content-title">{props.title}</h3>
			<p className="pc-content">{props.content}</p>
			{Boolean(props.link) && (
				<div className="pc-content-read-more-btn">
					<Button
						variant="link"
						onClick={() => redirect(props.link)}
						label={props.linkName || "Learn More"}
					/>
				</div>
			)}

			{props.secondContent && (
				<React.Fragment>
					<hr className="pc-announcement-hr" />
					<p className="pc-content slds-m-top_medium">{props.secondContent}</p>
					{Boolean(props.secondLink) && (
						<div className="pc-content-read-more-btn">
							<Button
								variant="link"
								onClick={() => redirect(props.secondLink)}
								label={props.linkName || "Learn More"}
							/>
						</div>
					)}
				</React.Fragment>
			)}
		</div>
	);
}

AnnouncementContent.propTypes = {
	id: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired,
	type: PropTypes.string.isRequired,
	content: PropTypes.string.isRequired,
	link: PropTypes.string,
	linkName: PropTypes.string,
	closeOverlay: PropTypes.func,
	secondContent: PropTypes.string,
	secondLink: PropTypes.string,
};

function AnnouncementContainer(props) {
	const intl = useIntl();
	const [search, setSearch] = React.useState("");
	const [allAnnouncements, setAllAnnouncements] = React.useState(announcements);

	const handleSearch = value => {
		let filteredAnnouncements = [];
		filteredAnnouncements = announcements.filter(announcement => {
			const titleMatch = announcement.title
				.toLowerCase()
				.includes(value.toLowerCase());
			const contentMatch = announcement.content.props.children
				.toString()
				.toLowerCase()
				.includes(value.toLowerCase());

			const secondContentMatch = announcement.secondContent?.props.children
				.toString()
				.toLowerCase()
				.includes(value.toLowerCase());

			return titleMatch || contentMatch || secondContentMatch;
		});
		setAllAnnouncements(filteredAnnouncements);
	};

	const handleChange = e => {
		setSearch(e.target.value);
		if (!e.target.value) {
			handleSearch("");
		}
	};

	const handleKeyDown = e => {
		if (e.key === "Enter") {
			handleSearch(search);
		}
	};

	return (
		<React.Fragment>
			<div className="pc-announcement-header">
				{intl.formatMessage({ id: "components.AnnouncementContainer.header" })}
				<Button
					iconCategory="utility"
					iconName="close"
					className="pc-close"
					onClick={props.closeOverlay}
				/>
			</div>
			<span className="pc-listing-search" data-cy="search">
				<input
					type="search"
					placeholder="Search"
					className="pc-listing-search-box pc-listing-search-box-focus"
					name="search"
					autoComplete="off"
					value={search}
					onChange={handleChange}
					onKeyPress={handleKeyDown}
				/>
			</span>
			<div className="pc-announcement-content">
				{allAnnouncements.length ? (
					<div className="pc-content-container" role="list">
						{allAnnouncements.map(content => (
							<AnnouncementContent
								key={content.id}
								{...content}
								closeOverlay={props.closeOverlay}
							/>
						))}
					</div>
				) : (
					<NoData
						className="no-data-div"
						image={
							<img
								className="emptyscreen-image-size"
								src={NoSearchResults}
								alt="No Data Img"
							/>
						}
						message={
							<div className="empty-conversations-text">
								<p>No result found</p>
								<span>
									There are no matching results. Check spelling errors and
									search again.
								</span>
							</div>
						}
					/>
				)}
			</div>
		</React.Fragment>
	);
}

AnnouncementContainer.propTypes = {
	closeOverlay: PropTypes.func.isRequired,
	intl: PropTypes.object,
};

export default AnnouncementContainer;
